import { CommonModule } from '@angular/common';
import { Component} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-head-menu',
  imports: [CommonModule],
  templateUrl: './header-menu.component.html',
})
export class HeadMenuComponent {
 }
